export default "__VITE_ASSET__CrupLHfz__"